module.exports = __webpack_public_path__ + "static/img/行业具备资料.59ed88c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/行业具备资料.png
// module id = C76C
// module chunks = 1